module.exports = __webpack_public_path__ + "img/Jackie Butler Premed club, 1969.dca153ac.jpg";